import { Button } from './ui/button';
import { ArrowRight, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

// Use public folder path so preload in index.html matches exactly
const heroBackground = '/assets/hero-mobile-mechanic-goldcoast.webp';

export const HeroSection = () => {
  const navigate = useNavigate();
  const [showEffects, setShowEffects] = useState(false);

  useEffect(() => {
    // Defer decorative effects until after LCP for better Speed Index
    const timer = setTimeout(() => setShowEffects(true), 150);
    return () => clearTimeout(timer);
  }, []);

  return <section id="home" className="min-h-screen relative flex items-center justify-center overflow-hidden pt-[94px]">
      {/* Hero background - optimized for LCP */}
      <div className="absolute inset-0">
        <img 
          src={heroBackground} 
          alt="Mobile Mechanic Gold Coast" 
          className="w-full h-full object-cover"
          loading="eager"
          fetchPriority="high"
          decoding="sync"
          style={{ contentVisibility: 'auto' }}
        />
      </div>
      
      {/* Simple overlay for text readability */}
      <div className="absolute inset-0 bg-black/50" />
      
      {/* Decorative effects - deferred for Speed Index */}
      {showEffects && (
        <>
          <div className="absolute inset-0 opacity-30 hidden md:block">
            <div className="absolute top-1/4 left-1/4 w-3 h-3 bg-primary rounded-full animate-pulse" />
            <div className="absolute top-3/4 right-1/4 w-2 h-2 bg-primary/60 rounded-full animate-pulse" />
          </div>
          <div className="absolute top-0 right-0 w-[40rem] h-[40rem] bg-gradient-to-bl from-primary/15 to-transparent rounded-full blur-3xl opacity-50 hidden lg:block" />
        </>
      )}
      
      {/* Content container */}
      <div className="relative z-10 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center pt-20 sm:pt-24 lg:pt-8 pb-16 sm:pb-20 lg:pb-24 flex flex-col min-h-screen justify-between">
        {/* Hero Content */}
        <div className="space-y-6 sm:space-y-8 lg:space-y-10 flex-1 flex flex-col justify-center">
          <div className="space-y-5 sm:space-y-7">
            {/* Main H1 Heading - instant display for Speed Index */}
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white tracking-wide">
              Trusted Mobile Car Servicing Gold Coast
            </h1>
            
            {/* Tagline - simplified gradient */}
            <p className="text-xl sm:text-2xl lg:text-3xl font-semibold tracking-wide uppercase text-slate-200">
              Convenience for Your Vehicle's Health Care
            </p>
          </div>

          

          {/* Trust indicators */}
          
          
          {/* Premium CTA buttons - positioned at bottom */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center mt-auto pt-12 sm:pt-16 lg:pt-20 mobile-flex-col">
            <Button onClick={() => navigate('/get-quote')} className="cta-button text-xl sm:text-2xl py-7 sm:py-8 px-10 sm:px-14 group font-bold w-full sm:w-auto">
              GET FREE QUOTE NOW
              <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button onClick={() => navigate('/book-now')} className="bg-white/10 backdrop-blur-sm hover:bg-white/20 border-2 border-white text-white hover:text-white font-bold text-xl sm:text-2xl py-7 sm:py-8 px-10 sm:px-14 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-xl shadow-lg w-full sm:w-auto">
              <Calendar className="mr-3 w-6 h-6" />
              BOOK SERVICE
            </Button>
          </div>

          {/* Social proof */}
          
        </div>
      </div>
    </section>;
};
